<template>
  <el-carousel :height="height+'px'" width="200px" :interval="3000" >
    <el-carousel-item v-for="item in sliderList" :key="item">
      <div class="b-banner-item clearfix">
<!--        <a :href="item.url">-->
        <img class="b-banner-img" :src="item.slidePicture" width="100%"/>
        <div class="b-info clearfix">
          <div class="b-title">
            {{ item.title }}
          </div>
        </div>
<!--        </a>-->
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
  import Header from "@/components/header/en/";
  import $ from "jquery";

  export default {
    data() {
      return {
        sliderList: [],
        height: 0
      };
    },
    mounted() {
      var self = this;
      self.height = 320;
      console.log("height is: "+self.height);
      this.sliderList = [
        {
          url: "",
          slidePicture: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rj01.jpg",
          IP_URL: Header.IP_URL,
          title: "Ruijin Base"
        },
        {
          url: "",
          slidePicture: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rj02.jpg",
          IP_URL: Header.IP_URL,
          title: "Ruijin Base"
        },
        {
          url: "",
          slidePicture: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rj03.jpg",
          IP_URL: Header.IP_URL,
          title: "Ruijin Base"
        },
        {
          url: "",
          slidePicture: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rj04.jpg",
          IP_URL: Header.IP_URL,
          title: "Ruijin Base"
        },
        {
          url: "",
          slidePicture: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rj05.jpg",
          IP_URL: Header.IP_URL,
          title: "Ruijin Base"
        }

      ];
    }
  };
</script>

<style lang="scss">
.b-banner-item{
  //position: relative;
  //height:calc(100% - 134px);
  .b-banner-img{
    position: relative;
    z-index: 1;
  }
  .b-info{
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 20px;
    background: #c8c9cc;
    z-index: 10;
    .b-title{
      color: #fff;
      font-size: 13px;
      line-height: 18px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/slider3/index.vue